export const WEB_IDENTITY_TOKEN_KEY = 'webIdentityToken'
